import styled from "styled-components";
import { HiChevronDown } from "react-icons/hi";

const AnchorContainer = styled.a`
    background: #FF5701;
    border-radius: 100%;
    color: #fff;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    width: 45px;
    font-size: 40px;
`;

type AnchorProps = {
    anchor: string;
};

const Anchor = ({ anchor }: AnchorProps) => {
    return (
        <AnchorContainer className="anchor" href={anchor}>
            <HiChevronDown />
        </AnchorContainer>
    );
};

export default Anchor;
